import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ImportTableService from "../../controller/ImportTables/ImportTable"; // Ensure the correct import
import Papa from 'papaparse';
import HelpSite from "../../../Common/HelpLink";
import Swal from 'sweetalert2';
import { handleSubmit } from "../../controller/ImportTables/CreateImportTable";
function ImportFile() {
    const { t } = useTranslation(); // Hook to access translations
    const navigate = useNavigate();
    const [importTableList, setImportTables] = useState([]); // Use array instead of object
    const [formData, setFormData] = useState({ TableID: "0" });
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);

    const [data, setData] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [importFields, setImportFields] = useState([]);
    const [selectedHeader, setSelectedHeader] = useState(null); // State to store selected header
    const [selectedRowIndex, setSelectedRowIndex] = useState(null); // State to store selected row in the second table
    const [fileLoaded, setFileLoaded] = useState(false); // State to track if the file is loaded
    const [loading, setLoading] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            Papa.parse(file, {
                header: true,
                complete: async (result) => {
                    const data = result.data;
                    setData(data);

                    if (data.length > 0) {
                        const headers = Object.keys(data[0]);
                        setHeaders(headers);

                        // Auto-mapping logic
                        const matchedFields = importFields.map((field) => {
                            const match = headers.find(
                                (header) =>
                                    header.toLowerCase().replace(/[\s_]+/g, '') ===
                                    field.vc_DisplayName.toLowerCase().replace(/[\s_]+/g, '')
                            );
                            return {
                                ...field,
                                csvColumnName: match || '', // Map or leave empty if no match
                            };
                        });

                        setImportFields(matchedFields);
                    }
                    setFileLoaded(true);
                },
            });
        }
    };

    useEffect(() => {
        async function fetchImportTables() {
            try {
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };
                let importTables = await ImportTableService.GetAllImportTable(redirectCallback);

                setImportTables(importTables || []); // Initialize formData with the fetched data
            } catch (error) {
                console.error('Error fetching Import Tables:', error);
            }
        }
        fetchImportTables();
    }, [navigate]);

    useEffect(() => {
        async function fetchImportFields() {
            if (formData.TableID && formData.TableID !== "0") {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    const fields = await ImportTableService.GetAllImportFields(redirectCallback, formData.TableID);
                    setImportFields(fields || []); // Set the fetched fields
                } catch (error) {
                    console.error('Error fetching Import Fields:', error);
                }
            }
        }
        fetchImportFields();
    }, [formData.TableID, navigate]);

    const handleHeaderClick = (header) => {
        setSelectedHeader(header);
    };

    const handleRowClick = (index) => {
        setSelectedRowIndex(index);
    };

    const handleAddHeaderToRow = () => {
        if (selectedHeader !== null && selectedRowIndex !== null) {
            const updatedImportFields = [...importFields];
            updatedImportFields[selectedRowIndex] = {
                ...updatedImportFields[selectedRowIndex],
                csvColumnName: selectedHeader,
            };
            setImportFields(updatedImportFields);
            setSelectedHeader(null); // Clear the selected header after adding
            setSelectedRowIndex(null); // Clear the selected row after adding
        }
    };

    const handleRemoveHeaderFromRow = () => {
        if (selectedRowIndex !== null) {
            const updatedImportFields = [...importFields];
            updatedImportFields[selectedRowIndex] = {
                ...updatedImportFields[selectedRowIndex],
                csvColumnName: '',
            };
            setImportFields(updatedImportFields);
            setSelectedRowIndex(null); // Clear the selected row after removing
        }
    };

    const handleFormSubmit = async (event) => {
        // Create a copy of formData to manipulate    
        try {
            if (formData.TableID === "0") {
                Swal.fire(
                    "Error",
                    "Please select a module.",
                    'error'
                );
                return;
            }
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const missingRequiredFields = importFields.filter(
                (field) => field.bit_Required === 1 && !field.csvColumnName
            );

            if (missingRequiredFields.length > 0) {

                Swal.fire(
                    "Error",
                    "Please map all required fields before submission.",
                    'error'
                );
                return;
            }

            const mappedTableData = data.map((row) => {
                const mappedRow = {};
                importFields.forEach((field) => {
                    const { csvColumnName, vc_FieldName } = field;
                    if (headers.includes(csvColumnName)) {
                        mappedRow[vc_FieldName] = row[csvColumnName];
                    }
                });
                return mappedRow;
            });

            setLoading(true);
            const payload = {
                TableID: formData.TableID,

                TableData: mappedTableData,
            };

            const postData = await handleSubmit(event, payload, redirectCallback);
            if (postData.ModuleMessage === "Not Exist") {
                Swal.fire(
                    "Error",
                    "Some categories or subcategories do not exist. Please create the required category or subcategory first.",
                    'error'
                );
            }
            else if (postData.ModuleMessage === "Customer Not Exist") {
                Swal.fire(
                    "Error",
                    "Some customers do not exist. Please create the required customer first.",
                    'error'
                );
            }
            else if (postData.message === "Courier added successfully") {
                Swal.fire(
                    "Success",
                    "The Data has been imported successfully",
                    'success'
                );
            }
            else if (postData.message) {
                Swal.fire(
                    "Error",
                    postData.message,
                    'error'
                );
            }
            else {
                Swal.fire(
                    "Error",
                    postData,
                    'error'
                );
            }
        }
        catch (error) {
            Swal.fire(
                "Error",
                error,
                'error'
            );
        } finally {
            setLoading(false); // Stop loading after fetching
        }


    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            {loading && (
                <div class="loading">
                    <div class="d-table">
                        <div class="d-tablecell">
                            <span class="loader">
                                <span class="loader-inner"></span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <div className="row mb-3">


                <label htmlFor="CompanyName" className="col-sm-2 col-form-label"> Link Module values</label>
                <div className="col-sm-4">
                    <select name="TableID" className="form-control" value={formData.TableID} onChange={handleChange}>
                        <option value="0">Select Module</option>
                        {importTableList.map((table) => (
                            <option key={table.PK_ImportTable_ID} value={table.PK_ImportTable_ID}>
                                {table.vc_DisplayName}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-sm-6" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="Imports" Module="26" />
                </div>
            </div>
            <div>
                <div className="row mb-3">
                    <div className="col-sm-4">
                        <input type="file" accept=".csv" onChange={handleFileChange} />
                    </div>
                </div>
            </div>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                <div className="col-sm-4" style={{ minHeight: "300px", border: "1px solid #dee2e6", maxHeight: "300px", overflow: "auto" }}>
                    <table className="table datatable table-bordered" style={{ marginTop: "5px" }}>
                        <thead>
                            <tr>
                                <th>Module Record Import</th>
                            </tr>
                        </thead>
                        <tbody>
                            {headers.map((header, index) => (
                                <tr
                                    key={index}
                                    onClick={() => handleHeaderClick(header)}
                                    className={`clickable-row ${header === selectedHeader ? 'selected' : ''}`}
                                    style={{
                                        backgroundColor: header === selectedHeader ? '#c5daed' : 'transparent' // Change color as needed
                                    }}
                                >
                                    <td>{header}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="col-sm-1 d-flex flex-column align-items-center justify-content-center">
                    <button onClick={handleAddHeaderToRow} disabled={!fileLoaded || selectedHeader === null || selectedRowIndex === null} className="btn btn-primary mb-2">&gt;&gt;</button>
                    <button onClick={handleRemoveHeaderFromRow} disabled={!fileLoaded || selectedRowIndex === null} className="btn btn-secondary">&lt;&lt;</button>
                </div>
                <div className="col-sm-7" style={{ minHeight: "300px", border: "1px solid #dee2e6", maxHeight: "300px", overflow: "auto" }}>

                    <table className="table datatable table-bordered" style={{ marginTop: "5px" }}>
                        <thead>
                            <tr>
                                <th>CSV Column Name</th>
                                <th>Module Value</th>
                                <th>Required</th>

                            </tr>
                        </thead>
                        <tbody>
                            {importFields.map((field, index) => (
                                <tr
                                    key={field.PK_ImportField_ID}
                                    onClick={() => handleRowClick(index)}
                                    className={`clickable-row ${index === selectedRowIndex ? 'selected' : ''}`}
                                    style={{
                                        backgroundColor: index === selectedRowIndex ? '#c5daed' : 'transparent',
                                        color: !field.csvColumnName && field.bit_Required === 1 ? 'red' : 'black', // Highlight required and unmatched fields
                                    }}
                                >
                                    <td>{field.csvColumnName || ''}</td>
                                    <td>{field.vc_DisplayName}</td>
                                    <td>{field.bit_Required === 1 ? 'Yes' : 'No'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                <div className="col-sm-12" style={{ minHeight: "300px", border: "1px solid #dee2e6", maxHeight: "600px", overflow: "auto", maxWidth: "98%" }}>
                    <table className="table datatable table-bordered">
                        <thead>
                            <tr>
                                {headers.map((header, index) => (
                                    <th key={index}>{header}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((row, index) => (
                                <tr key={index}>
                                    {headers.map((header, headerIndex) => (
                                        <td key={headerIndex}>{row[header]}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>

                <div className="col-sm-12" >
                    <button type="submit" className="btn btn-primary" onClick={(event) => handleFormSubmit(event)} style={{ float: "right" }}>
                        <i className="icofont-save" aria-hidden="true">Save</i>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ImportFile;
